module.exports = __webpack_public_path__ + "img/dji.423c4156.svg";